var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.21975 5.53187L3.80325 9.11537C3.90814 9.22023 4.04176 9.29163 4.18723 9.32056C4.33269 9.34948 4.48347 9.33463 4.62049 9.27788C4.75751 9.22113 4.87464 9.12502 4.95705 9.00171C5.03946 8.87841 5.08347 8.73343 5.0835 8.58512L5.0835 6.31412C5.0835 6.26439 5.10325 6.2167 5.13842 6.18154C5.17358 6.14637 5.22127 6.12662 5.271 6.12662L16.875 6.12662C17.1734 6.12662 17.4595 6.00809 17.6705 5.79712C17.8815 5.58614 18 5.29999 18 5.00162C18 4.70325 17.8815 4.4171 17.6705 4.20613C17.4595 3.99515 17.1734 3.87662 16.875 3.87662L5.271 3.87662C5.22127 3.87662 5.17358 3.85687 5.13842 3.8217C5.10325 3.78654 5.0835 3.73885 5.0835 3.68912L5.0835 1.41812C5.08347 1.26981 5.03947 1.12483 4.95705 1.00153C4.87464 0.878218 4.75752 0.782114 4.62049 0.725362C4.48347 0.668608 4.33269 0.653756 4.18723 0.682682C4.04176 0.711608 3.90814 0.783013 3.80325 0.887871L0.21975 4.47137C0.0791458 4.61202 0.000160614 4.80275 0.000160596 5.00162C0.000160579 5.20049 0.0791458 5.39122 0.21975 5.53187Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ae79794b777dee22601c2d3f76c89171.svg";
export { ForwardRef as ReactComponent };